import { DrizzleAppSchema } from '@powersync/drizzle-driver';
import { eq } from 'drizzle-orm';
import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export enum TimerState {
  Running = 'running',
  Paused = 'paused',
  Stopped = 'stopped',
}

const timers = sqliteTable('timers', {
  id: text().primaryKey().notNull(),
  workspaceId: text('workspace_id').notNull(),
  docId: text('doc_id').notNull(),
  state: text().$type<TimerState>().notNull().default(TimerState.Stopped),
  total: integer().notNull(),
  elapse: integer().notNull().default(0),
  startedAt: text('started_at').notNull(),
  createdAt: text('created_at').notNull(),
  updatedAt: text('updated_at').notNull(),
});

const schema = {
  timers,
};

const AppSchema = new DrizzleAppSchema(schema);

export { AppSchema, eq, schema };
